<div class="verify-email">
  <sync-dialog
    [config]="{
      title: 'Verify your account',
      isClosable: false,
      closeIcon: (cancelButtonText === 'Back') ? 'arrow-left' : 'close',
      onCloseIcon: onBack,
      cancelButton: cancelButtonText,
      onCancelClick: onBack,
      actionButton: success?'':'Re-send verification',
      onActionClick: onSend,
      isButtonLoading: spinner,
    }"
    [open]="showDialog"
    [isFullScreen]="false"
  >
    <div class="verify-email-container">
      <app-error *ngIf="errcode" [errcode]="errcode"></app-error>
      <div class="body-1" *ngIf="!success">
        {{message}}
      </div>
      <div *ngIf="success">
        <sync-alert
        [type]="'promo'"
        [leadIcon]="'info'"
        [showLeadIcon]="true"
        [title]="'Verification email sent.'"
        [description]="description"
        [showActions]="false"
        [showPrimaryAction]="false"
        [showSecondaryAction]="false"
        [showCloseButton]="false"
      ></sync-alert>
      </div>
    </div>
  </sync-dialog>
</div>
